import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const PlayCircleOutlinedIcon = (props) => (React__default.createElement(SvgIcon, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none", style: Object.assign(Object.assign({}, props.style), { borderRadius: '50%', background: '#406AE3' }), viewBox: "0 0 32 32" }, props),
    React__default.createElement("rect", { width: 30, height: 30, x: 1, y: 1, fill: "#2B59E0", rx: 15 }),
    React__default.createElement("rect", { width: 30, height: 30, x: 1, y: 1, stroke: "#fff", rx: 15 }),
    React__default.createElement("path", { fill: "#fff", d: "M23 15.425a1 1 0 0 1 0 1.732l-9 5.196a1 1 0 0 1-1.5-.866V11.095a1 1 0 0 1 1.5-.867l9 5.197Z" })));

export { PlayCircleOutlinedIcon };
